import React from 'react';
import CriteriaConditionRow from './CriteriaConditionRow';
import { emptyCondition, emptyGroup } from './criteriaUtils';

const CriteriaGroupNode = ({ node, path, onChange, onRemove, onAppend }) => {
  const isRoot = path.length === 0;

  return (
    <div className="criteria-group">
      <div className="criteria-group-head">
        <span className="criteria-group-label">{isRoot ? 'Root' : 'Group'}</span>
        <select
          className="criteria-op-select"
          value={node.op || 'AND'}
          onChange={(e) => onChange(path, (n) => ({ ...n, op: e.target.value }))}
        >
          <option value="AND">AND</option>
          <option value="OR">OR</option>
        </select>
        <button
          type="button"
          className="criteria-btn-sm"
          onClick={() => onAppend(path, emptyCondition())}
        >
          Add condition
        </button>
        <button type="button" className="criteria-btn-sm" onClick={() => onAppend(path, emptyGroup())}>
          Add group
        </button>
        {!isRoot && (
          <button type="button" className="criteria-btn-sm criteria-btn-danger" onClick={() => onRemove(path)}>
            Remove group
          </button>
        )}
      </div>
      <div className="criteria-group-children">
        {!node.children?.length ? (
          <p className="criteria-empty">No conditions yet. Add a condition or a nested group.</p>
        ) : (
          node.children.map((child, i) => {
            const childPath = [...path, i];
            if (child.kind === 'group') {
              return (
                <CriteriaGroupNode
                  key={childPath.join('-')}
                  node={child}
                  path={childPath}
                  onChange={onChange}
                  onRemove={onRemove}
                  onAppend={onAppend}
                />
              );
            }
            return (
              <CriteriaConditionRow
                key={childPath.join('-')}
                condition={child}
                path={childPath}
                onChange={onChange}
                onRemove={onRemove}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default CriteriaGroupNode;
